<template>
  <div class="notifications">
    <slide-y-up-transition
      :duration="transitionDuration"
      group
      tag="div"
      class="notifications-stack"
    >
      <notification
        v-for="item in positionedNotifications"
        v-bind="item.notification"
        :clickHandler="item.notification.onClick"
        :key="getNotificationKey(item.notification)"
        :stack-index="overlap ? 0 : item.stackIndex"
        @close="removeNotification"
      />
    </slide-y-up-transition>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, watchEffect } from "vue";
import { SlideYUpTransition } from "vue2-transitions";

import Notification from "./Notification.vue";
import { useNotify } from "@/composables/useNotify.js";
import { safeArray } from "@/helpers/functions/ArrayHelpers.js";

export default defineComponent({
  components: {
    SlideYUpTransition,
    Notification,
  },
  name: "TheNotifications",
  props: {
    transitionDuration: {
      type: Number,
      default: 200,
    },
    overlap: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const $notifications = useNotify();
    const notificationIndexes = new Map();

    const notifications = computed(() => safeArray($notifications?.state));
    const positionedNotifications = computed(() => {
      if (!notifications.value.length) {
        notificationIndexes.clear();
      }

      return notifications.value.map((notification) => {
        const key = getNotificationKey(notification);

        if (!notificationIndexes.has(key)) {
          notificationIndexes.set(key, notificationIndexes.size);
        }

        return {
          notification,
          stackIndex: notificationIndexes.get(key),
        };
      });
    });

    function getNotificationKey(notification) {
      return notification.timestamp?.getTime?.() || notification.timestamp;
    }

    function removeNotification(timestamp) {
      $notifications.removeNotification(timestamp);
    }

    onMounted(() => {
      try {
        $notifications.settings.overlap = props.overlap;
      } catch (error) {}
    });

    watchEffect(() => ($notifications.settings.overlap = props.overlap));

    return {
      positionedNotifications,
      getNotificationKey,
      removeNotification,
    };
  },
});
</script>
<style scoped lang="scss">
.notifications {
  position: fixed;
  z-index: 10000;
  top: 20px;
  right: 20px;
  pointer-events: none;
  min-width: max-content;
}

.notifications-stack {
  position: relative;
  width: 100%;
}
</style>
